import { useCallback, useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TrackedButton } from 'growth-payments-core/usage-tracker/components/Button';
import { events } from 'growth-payments-core/usage-tracker/events';
import { EnrollmentFlowType } from '../../types';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import CelebrationModalV2 from './CelebrationModalV2';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { usePaymentsEnrollmentUtilitiesContext } from '../../context/PaymentsEnrollmentUtilitiesContext';
import { track } from 'growth-payments-core/usage-tracker/track';
import { getCommerceHomeUrl } from 'growth-payments-core/urls/urls';
import { navigateTo } from 'growth-payments-core/urls/utils';
import { addSuccessAlert } from 'growth-payments-core/alerts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  PRE_APPROVAL_SUCCESS_MODAL_PRIMARY_BUTTON: 'pre-approval-success-modal-primary-button',
  PRE_APPROVAL_SUCCESS_MODAL_SECONDARY_BUTTON: 'pre-approval-success-modal-secondary-button'
};
const PreApprovedApplicationSuccessModalV2 = ({
  onClose,
  shouldReloadOnEnrollmentComplete = true
}) => {
  const {
    currentEnrollmentFlow,
    businessTypeDetails,
    location
  } = usePaymentsEnrollmentUtilitiesContext();
  const [, setCurrentEnrollmentFlow] = useQueryStringState('paymentsEnrollment', EnrollmentFlowType.processorPicker);
  const handleClick = useCallback(() => {
    setCurrentEnrollmentFlow(null);
    if (shouldReloadOnEnrollmentComplete) {
      return navigateTo(getCommerceHomeUrl());
    } else {
      onClose();
    }
  }, [setCurrentEnrollmentFlow, shouldReloadOnEnrollmentComplete, onClose]);
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  useEffect(() => {
    const alertMessage = currentEnrollmentFlow === EnrollmentFlowType.stripe ? 'preApprovedApplicationSuccessModal.successAlertMessageStripe' : 'preApprovedApplicationSuccessModal.successAlertMessageNative';
    addSuccessAlert({
      title: 'preApprovedApplicationSuccessModal.successAlertTitle',
      message: alertMessage
    });
  }, [currentEnrollmentFlow]);
  useEffect(() => {
    Metrics.counter('stripe-success-modal-viewed', {
      businessType: businessType || '',
      businessStructure: businessStructure || ''
    }).increment();
  }, [businessStructure, businessType]);
  const renderCta = useCallback(() => {
    const primaryCtaTrackingAction = 'goToCommerceOverviewButtonClicked';
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(TrackedButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: primaryCtaTrackingAction,
          location: 'pre-approved-application-success-modal'
        },
        "data-test-id": TEST_IDS.PRE_APPROVAL_SUCCESS_MODAL_PRIMARY_BUTTON,
        use: "primary",
        onClick: handleClick,
        children: shouldReloadOnEnrollmentComplete ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.secondaryCta"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.continue"
        })
      })
    });
  }, [handleClick, shouldReloadOnEnrollmentComplete]);
  const title = currentEnrollmentFlow === EnrollmentFlowType.stripe ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.headerStripe"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.headerNative"
  });
  const body = currentEnrollmentFlow === EnrollmentFlowType.stripe ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.bodyStripe"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.bodyNative"
  });
  return /*#__PURE__*/_jsx(CelebrationModalV2, {
    currentEnrollmentFlow: currentEnrollmentFlow,
    title: title,
    subTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "preApprovedApplicationSuccessModal.subTitle"
    }),
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TrackRender, {
        event: events.growthPaymentsPageView,
        properties: {
          screen: 'kyc-pre-approval-success-modal',
          location
        }
      }), body, shouldReloadOnEnrollmentComplete && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "preApprovedApplicationSuccessModal.goToCommerceOverview"
      })]
    }),
    testID: "kyc-success-modal",
    onClose: () => {
      track(events.paymentSettingsInteraction, {
        action: 'cancelButtonClicked',
        location: 'pre-approved-application-success-modal'
      });
      handleClick();
    },
    primaryCTA: renderCta()
  });
};
export default PreApprovedApplicationSuccessModalV2;